import { AdminFeedbackResponse } from "../contracts/AdminFeedbackResponse";
import { AdminFeedbackEntry } from "../models/AdminFeedbackEntry";

export const mapResponseToAdminFeedbackEntry = (
  response: AdminFeedbackResponse
): AdminFeedbackEntry => ({
  id: response.id,
  instructorId: response.instructorId,
  audience: response.audience,
  memberId: response.memberId,
  firstName: response.firstName,
  lastName: response.lastName,
  email: response.email,
  type: response.type,
  message: response.message,
  dateCreated: new Date(response.dateCreated),
});
